import { useTranslation } from "next-i18next";
import { sharedServerSideProps } from "@/src/utils/sharedServerSideProps";
import PageHead from "@/src/shared/PageHead";
import Header from "@/src/shared/Header/Header";
import MobileMenu from "@/src/shared/Header/subs/MainHeader/MobileMenu";
import Separator from "@/src/shared/Separator";
import Footer from "@/src/shared/Footer";
import BackToTop from "@/src/shared/BackToTop";
import ContactUsPage from "@/src/features/contact-us/ContactUsPage";

export default function Contact() {
  const { t } = useTranslation();

  return (
    <>
      <PageHead title={t("contactUs")} />
      <Header />
      <MobileMenu />
      <ContactUsPage />
      <BackToTop />
      <Separator />
      <Footer />
    </>
  );
}

export const getServerSideProps = sharedServerSideProps(async () => {
  return {};
});
